<template>
    <div ref="container">
      <a-modal :title="title" :width='1000' :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 50%;">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
            <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典内容名称" prop="dicName">
                  <a-input placeholder="请输入字典内容名称" v-model="form.dictLable" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="内容排序" prop="dicCode">
                  <a-input placeholder="请输入内容排序" v-model="form.dictSort" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典内容值" prop="dicCode">
                  <a-input placeholder="请输入字典内容值" v-model="form.dictValue" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典备注" prop="dicCode">
                  <a-input placeholder="请输入字典备注" v-model="form.remark" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-spin>
      </a-modal>
    </div>
  </template>
  <script>
    import { dictDataAdd, dictDataEdit, dictDataDelete } from '@/api/api'
    import { mixinDevice } from '@/utils/mixin'
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import Vue from 'vue'
    import { ACCESS_TOKEN } from '@/store/mutation-types'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
    },
    data() {
      return {
        title: '操作',
        visible: false,
        confirmLoading: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        columns: [
          { title: '内容名称', dataIndex: 'dictLable', width: 70, align: 'left' },
          { title: '内容排序', dataIndex: 'dictSort', width: 70, align: 'left' },
          { title: '内容值', dataIndex: 'dictValue', width: 70, align: 'left' },
          {
            title: '备注',
            dataIndex: 'remark',
            width: 100,
            align: 'left',
          },
          {
            title: '字典内容',
            dataIndex: 'action',
            width: 80,
            align: 'center',
            scopedSlots: { customRender: 'action' },
          },
        ],
        form: {},
        id: null,
        getDataId: null,
      }
    },
    created() {},
    methods: {
        show(e,dictId){
            console.log(e,'传递的值==============')
            this.visible = true
            if( e && dictId ){
                this.title = '编辑字典内容'
                this.form = e
                this.getDataId = e.id
                this.id = dictId
            } else {
                this.title = '新增字典内容'
                this.id = e
            }
        },
        close() {
            this.$emit('close')
            this.visible = false
        },
        handleOk() {
            const that = this
            // 触发表单验证
            that.$refs['form'].validate(async (success) => {
            if (success === true) {
                let params = {
                    dictId: this.id || '',
                    dictLable: this.form.dictLable || '',
                    dictSort: this.form.dictSort || '',
                    dictValue: this.form.dictValue,
                    remark: this.form.remark,
                }
                if (this.getDataId) {
                    // 编辑
                    params.id = this.getDataId
                    const res = await dictDataEdit(params)
                    if ( res.code == 200 && res.success == true ) {
                        this.$message.success( res.result )
                        this.close()
                        // 清空form
                        this.form = {}
                        this.getDataId = null
                        this.id = null
                    } else {
                        this.$message.error(res.data || res.result)
                    }
                } else {
                    const res = await dictDataAdd(params)
                    if ( res.code == 200 && res.success == true ) {
                        this.$message.success( res.result )
                        this.close()
                        this.form = {}
                        this.getDataId = null
                        this.id = null
                    } else {
                        this.$message.error(res.data || res.result)
                    }
                }
            }
            })
        },                    
        handleCancel() {
            this.close()
        },
    },
  }
  </script>
  <style scoped>
  </style>